import type {AxiosInstance} from 'axios';

const defaultClientHeader = {};
const defaultServerHeader = {'accept-encoding': 'gzip, deflate'};

export const getAxios = async (baseURL?: string): Promise<AxiosInstance> => {
  const {default: axios} = await import('axios');

  return axios.create({
    baseURL,
    headers: Object.assign(
      process.browser ? defaultClientHeader : defaultServerHeader,
    ),
    timeout: 10000,
    validateStatus: status => status !== 500,
  });
};
